import React from 'react';
import type { ESignPackage } from '../../types/docmagic';
import type { BusyAction } from '../../hooks/usePackages';
import { ParticipantsTable } from '../details/ParticipantsTable';
import { SignedPdfCard } from '../details/SignedPdfCard';
import { SyncLog } from '../details/SyncLog';
interface DetailsTabProps {
  pkg: ESignPackage;
  busy?: BusyAction;
  onRetryPdf: () => void;
}
export function DetailsTab({
  pkg,
  busy,
  onRetryPdf
}: DetailsTabProps) {
  return <div className="space-y-4" data-id="element-145" data-mp="24alwauccb1ec">
      <ParticipantsTable pkg={pkg} data-id="element-146" data-mp="24ac6b6raou8n" />
      <div className="grid gap-4 lg:grid-cols-[minmax(0,1fr)_minmax(0,2fr)]" data-id="element-147" data-mp="24betp4pesejt">
        <SignedPdfCard pkg={pkg} busy={busy} onRetry={onRetryPdf} data-id="element-148" data-mp="1za7lj4jctdcm" />
        <SyncLog logs={pkg.logs} data-id="element-149" data-mp="1vagoij38i0zn" />
      </div>
    </div>;
}